import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { IndividualScreenings } from '../../health.model';
import { TylerMatTableDataSource } from '../../../../shared-components/angular-material/extended.class';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-screening-detail',
  templateUrl: './screening-detail.component.html'
})
export class ScreeningDetailComponent implements OnInit {

  @Input() screeningdetail: IndividualScreenings[];
  @Input() screeningId: number;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  // ----------Angular Material------------------------------------
  angularMatData = new TylerMatTableDataSource();
  displayColumns: string[] = [];

  constructor() {
  }

  ngOnInit() {
    this.displayColumns.push('ScreenedDate');
    if (this.screeningId != 8 && this.screeningId != 3 && this.screeningId != 9) {
      this.displayColumns.push('SeriesName');
    }
    if (this.screeningId == 9) {
      this.displayColumns.push('SportsScreening');
    }
    if (this.screeningId != 9) {
      this.displayColumns.push('ScheduledDate');
    }
    if (this.screeningId != 3) {
      this.displayColumns.push('ResultCode');
      this.displayColumns.push('Referral');
    }
    if (this.screeningId == 9) {
      this.displayColumns.push('ReferralStatus');
    }
    if (this.screeningId != 3 && this.screeningId != 9) {
      this.displayColumns.push('Comments');
    }
    if (this.screeningId == 3) {
      this.displayColumns.push('Height', 'Weight', 'BMI', 'BMIPercentile');

    }

    this.angularMatData = new TylerMatTableDataSource(this.screeningdetail);
    setTimeout(() => this.angularMatData.sort = this.sort);
  }

}
